import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../data/mock";
import { Clock, ArrowRight } from "lucide-react";

export default function BlogTeaser() {
  return (
    <section id="stories" className="py-24 md:py-32 bg-[var(--mm-bg-alt)] border-t border-b border-[var(--mm-line)]">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-12 fade-in">
          <div>
            <div className="section-label mb-4">Stories</div>
            <h2 className="font-display text-5xl md:text-7xl italic font-light text-[var(--mm-cream)] leading-[0.95]">
              From the <span className="text-[var(--mm-accent)]">kitchen.</span>
            </h2>
          </div>
          <Link to="/blog" className="hidden md:inline-block link-underline text-[var(--mm-accent)] text-xs tracking-[0.28em] uppercase">
            Read all stories
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group fade-in">
              <div className="img-hover aspect-[4/3] overflow-hidden mb-5">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex items-center gap-4 text-xs tracking-[0.24em] uppercase text-[var(--mm-cream-muted)] mb-3">
                <span>{p.date}</span>
                <span className="flex items-center gap-1.5"><Clock size={11} /> {p.readMins} min read</span>
              </div>
              <h3 className="font-display italic text-2xl text-[var(--mm-cream)] leading-tight mb-3 group-hover:text-[var(--mm-accent)] transition-colors">
                {p.title}
              </h3>
              <p className="text-sm text-[var(--mm-cream-muted)] font-light leading-relaxed mb-4">{p.excerpt}</p>
              <span className="inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase text-[var(--mm-accent)] link-underline">
                Read <ArrowRight size={12} />
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center md:hidden fade-in">
          <Link to="/blog" className="link-underline text-[var(--mm-accent)] text-xs tracking-[0.28em] uppercase">
            Read all stories
          </Link>
        </div>
      </div>
    </section>
  );
}
